import { render, staticRenderFns } from "./SideNavIcon.vue?vue&type=template&id=494b6f62&"
import script from "./SideNavIcon.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideNavIcon.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SideNavIcon.vue?vue&type=style&index=0&id=494b6f62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports